
<template>
    <div id="panel-users" class="panel" v-if="is_comerc">
        <div  class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>Учасники</h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show">
            <div class="panel-content">
                <div class="user_list">
                    <ul>
                        <li  v-for="user in users">
                            <div v-if="user.role == 'sale'">
                                <BTooltip
                                    :target="`user-${user.user_id}`"
                                    placement="top"
                                    :html="true"
                                    :title="user.info.contact_name + ' (' + user.info.contact_tel + ')'"
                                />
                                
                                <span :id="`user-${user.user_id}`"
                                    :style="{ color: user.role === 'sale' && user.online ? 'green' : (user.role === 'sale' ? 'red' : '') }"
                                    class="cursor-pointer"
                                    @click="viewuser(user.user_id)"
                                    v-if="user.role === 'sale'"
                                >
                                {{ user.info.company }}
                              </span>
                            </div>
                            
                            <div v-else>
                                <BTooltip :target="`user-${user.user_id}-default`" placement="top" :html="true" title="Співробітник"/>
                                
                                <span :id="`user-${user.user_id}-default`" style="color: orange;" >
                                    {{ user.info.name }}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    BTooltip,
} from 'bootstrap-vue-next';

export default {
    name: "reduction_users",
    components : {
        BTooltip
    },
    props : {
        user_role  : {
            type : String,
            default : 'comerc',
        }
    },
    
    methods : {
        viewuser(user_id) {
            let _href = '/kontrahenty/' + user_id
            window.open(_href, '_blank');
        },
    },
    
    computed : {
        ...mapGetters({
            'users': "reduction/getUsers",
        }),
        
        is_comerc: function () {
            return this.user_role === 'comerc';
        },
        
    }
}
</script>


<style scoped>

</style>